<template>
  <el-cascader
    ref="cascader"
    :style="{ width: width }"
    size="small"
    v-model="data"
    v-bind="$attrs"
    :options="selectOptions"
    @change="handleChange"
    :props="{
      checkStrictly: multiple,
      value: 'id',
      label: 'name',
      children: 'subs'
    }"
    filterable
    clearable
  >
  </el-cascader>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String]
    },
    query: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '200px'
    }
  },
  created() {
    if (this.$api.common.department_all) {
      this.$ajax.get(this.$api.common.department_all).then((data) => {
        this.selectOptions = data.data
      })
    }
  },
  data() {
    return {
      data: [],
      selectOptions: []
    }
  },
  watch: {
    value(val) {
      this.data = val
    }
  },
  methods: {
    getCheckNode() {
      return this.$refs.cascader.getCheckedNodes()
    },
    handleChange(val) {
      this.$emit('input', val)
    }
  }
}
</script>
